import React from 'react';

const VideoGrid = ({ videos }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: '40px',
        animation: 'fadeIn 0.5s ease-in'
      }}
    >
      {videos.map((video) => (
        <div
          key={video.id}
          style={{
            overflow: 'hidden',
            background: 'var(--charcoal)',
            borderRadius: '0px'
          }}
        >
          <video
            controls
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
            preload="metadata"
          >
            <source src={video.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      ))}
    </div>
  );
};

export default VideoGrid;
